import utils from 'utils'

class searchDeclarationDetailCtrl {
    constructor($scope, $stateParams) {
        $scope.url = encodeURI(JSON.parse(utils.decode($stateParams.obj)).url)
        $(() => {
            $('body').addClass('leftnav-close ie11-overflow')
            $('#wrapper').addClass('top-nav-close')
        })
    }
}

searchDeclarationDetailCtrl.$inject = ['$scope', '$stateParams']
export default searchDeclarationDetailCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxDeclaration/searchDeclaration/searchDeclarationDetailCtrl.js